"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var common_translations_1 = require("../../../../shared/core/common-translations");
var defaultTranslations = (0, deepmerge_1.default)(common_translations_1.translations, {
    en: {
        meterSummary: {
            msnLabel: '$t(common.msnFull): {{msn}}',
            omrNoRecentIndustryRead: '<P>We can’t accept a reading for this meter online, because we haven’t had a network reading in over 12 months. You’ll need to contact us to arrange this.</P>',
            omrAwaitingIndustryData: '<P>We’re still waiting on industry data for this meter.</P>',
        },
    },
});
var defaultOptions = {
    defaultTranslations: defaultTranslations,
};
exports.defaultOptions = defaultOptions;
